/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { SparseMatrixDependencies } from './dependenciesSparseMatrixClass.generated.js';
import { absDependencies } from './dependenciesAbs.generated.js';
import { addDependencies } from './dependenciesAdd.generated.js';
import { divideScalarDependencies } from './dependenciesDivideScalar.generated.js';
import { largerDependencies } from './dependenciesLarger.generated.js';
import { largerEqDependencies } from './dependenciesLargerEq.generated.js';
import { multiplyDependencies } from './dependenciesMultiply.generated.js';
import { subtractDependencies } from './dependenciesSubtract.generated.js';
import { transposeDependencies } from './dependenciesTranspose.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createSlu } from '../../factoriesAny.js';
export var sluDependencies = {
  SparseMatrixDependencies,
  absDependencies,
  addDependencies,
  divideScalarDependencies,
  largerDependencies,
  largerEqDependencies,
  multiplyDependencies,
  subtractDependencies,
  transposeDependencies,
  typedDependencies,
  createSlu
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesSlu.generated.js
// module id = 568
// module chunks = 2